<template>
    <div id="MyProfileDiv">
      <HeaderVue isHeader="true"/>
      <div class="container-fluid static-content">
        <div class="row">
          <div class="col-12">
              <div class="signup-title">
                  <h4 class="mt-0 mb-0">My Account</h4>
              </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12">
              <div class="form-content line-textbox">
                  <div class="d-flex credit-box">
                      <!--<div class="testimonial-dp float-none">
                          <img src="images/profile.jpg" class="img-fluid" alt="">
                      </div>-->
                      <div class="credit-points">
                          <div class="d-flex">
                              <div class="pr-3">
                                  <h1 class="m-0">{{creditPoint}}</h1>
                                  <p>Credits</p>
                              </div>
                              <div class="referral-code">
                                  <h3 class="m-0">{{referralCode}}</h3>
                                  <h6>Referral Code</h6>
                              </div>
                          </div>
                          <h1 class="credit-icon">
                              <i class="fa fa-certificate"></i>
                          </h1>
                      </div>
                  </div>
                  <br>
                  <router-link to= "/referral/invite"><button class="btn btn-outline-primary w-100 mb-3">Refer & Earn</button></router-link>
                  <label>{{firstName + ' ' + lastName}}</label>
                  <label>{{email}}</label>
                  <label>{{phone1}}</label>
                  <!-- <router-link to="/changepassword">Change Password</router-link> -->
                  <a href="#" data-toggle="modal" data-target="#changePassword">Change Password</a>
                  <div class="row mt-3 mb-3"> 
                      <div class="col-12">
                          <button class="btn btn-primary full-width" data-toggle="modal" data-target="#editProfile">Edit</button>
                      </div>
                  </div>
              </div>  
          </div>
        </div>
      </div>
      <div class="contact-info">
          <div class="container">
              <ul class="row text-center">
                  <!-- <li>
                      <span class="sprites sprite-chat align-center"></span>
                      <p>Chat</p>
                  </li> -->
                  <li>
                      <span class="sprites sprite-mail align-center"></span>
                      <p><a href="mailto:support@labotist.com" target="_top"> support@labotist.com </a></p>
                  </li>
                  <li>
                      <span class="sprites sprite-call align-center"></span>
                      <p><a href="tel:+919025662566">+91 90256 62566</a></p>
                  </li>
              </ul>
          </div>
      </div>
      <FooterVue />
      <div class="modal fade" id="changePassword" tabindex="-1" role="dialog" aria-labelledby="changePasswordLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">
                            &times;
                        </span>
                    </button>
                    <h5 class="modal-title" id="changePasswordLabel">
                        Change Password
                    </h5>
                </div>
                <div class="modal-body">
                  <form data-vv-scope="password">
                    <div class="form-content line-textbox">
                        <p class="no-mar-top red-color" v-if="error">{{errormsg}}</p>
                        <div class="form-group">
                            <label>Type Current Password</label>
                            <input class="form-control" type="password" name="oldPassword" data-vv-as="current password" v-model="oldPassword" v-validate="'required'">
                            <span v-show="errors.has('password.oldPassword')" class="text-danger">{{ errors.first('password.oldPassword') }}</span>
                        </div>
                        <div class="form-group">
                            <label>Type New Password</label>
                            <input class="form-control" type="password" name="newPassword" data-vv-as="new password" v-model="newPassword" v-validate="'required'">
                            <span v-show="errors.has('password.newPassword')" class="text-danger">{{ errors.first('password.newPassword') }}</span>
                        </div>
                        <div class="form-group">
                            <label>Retype New Password</label>
                            <input class="form-control" type="password" name="confirmPassword" data-vv-as="retype new password" v-model="confirmPassword" v-validate="'required'">
                            <span v-show="errors.has('password.confirmPassword')" class="text-danger">{{ errors.first('password.confirmPassword') }}</span>
                            <span v-show="confirmPassword !== '' && newPassword !== confirmPassword" class="text-danger">The retype new password confirmation does not match</span>
                        </div>
                        <button class="btn btn-primary full-width" data-dismiss="modal" aria-label="Close" @click.prevent="savePassword()" :disabled="(errors.any())">CHANGE PASSWORD</button>
                    </div>
                  </form>
                </div>      
            </div>
        </div>
      </div>
      <div class="modal fade" id="editProfile" tabindex="-1" role="dialog" aria-labelledby="editProfileLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">
                            &times;
                        </span>
                    </button>
                    <h5 class="modal-title" id="editProfileLabel">
                        Edit Profile
                    </h5>
                </div>
                <div class="modal-body">
                  <form data-vv-scope="edit">
                    <div class="clearfix line-textbox mt-4">
                        <div class="form-group">
                            <label>First Name</label>
                            <input class="form-control" type="text" name="firstName" data-vv-as="first name" v-model="firstName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                            <span v-show="errors.has('edit.firstName')" class="text-danger">{{ errors.first('edit.firstName') }}</span>
                        </div>
                        <div class="form-group">
                            <label>Last Name</label>
                              <input class="form-control" name="lastName" type="text" data-vv-as="last name" v-model="lastName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                              <span v-show="errors.has('edit.lastName')" class="text-danger">{{ errors.first('edit.lastName') }}</span>
                        </div>
                        <div class="form-group">
                            <label>Gender</label> <br>
                            <div class="form-check form-check-inline">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="sex" :checked="(sex === 'M')?true:false"> Male
                                    <!-- <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="Male"> Male -->
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="sex" :checked="(sex === 'F')?true:false"> Female
                                    <!-- <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="Female"> Female -->
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="radio" name="gender" id="inlineRadio3" value="O" v-model="sex" :checked="(sex === 'O')?true:false"> Other
                                    <!-- <input class="form-check-input" type="radio" name="gender" id="inlineRadio3" value="Others"> Others -->
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Date of birth</label>
                            <!-- <div class="input-group"> -->
                              <div class="row">
                                  <div class="col-4">
                                      <select class="form-control" name="year" id="year"  v-model="year" v-on:change="getNumberOfDays()">
                                          <option value="" class="dobOptionColor" disabled selected>YYYY</option>
                                          <option v-for="(dobYear, index) in dobYears" v-bind:value="dobYear" :key='index'>{{dobYear}}</option>
                                      </select>
                                  </div>
                                  <div class="col-4">
                                      <select class="form-control" name="month" id="month" v-model="month" v-on:change="getNumberOfDays()">
                                          <option value="" class="dobOptionColor" disabled selected>MMM</option>
                                          <option value="01">Jan</option>
                                          <option value="02">Feb</option>
                                          <option value="03">Mar</option>
                                          <option value="04">Apr</option>
                                          <option value="05">May</option>
                                          <option value="06">Jun</option>
                                          <option value="07">Jul</option>
                                          <option value="08">Aug</option>
                                          <option value="09">Sep</option>
                                          <option value="10">Oct</option>
                                          <option value="11">Nov</option>
                                          <option value="12">Dec</option>
                                      </select>
                                  </div>
                                  <div class="col-4">
                                  <select class="form-control" name="ddate" id="ddate" v-model="ddate">
                                      <option value="" class="dobOptionColor" disabled selected>DD</option>
                                      <option v-for="(dobDateVal, index) in dobDate" v-bind:value="dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''" :key='index'>{{dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : '' }}</option>
                                  </select>
                                  </div>
                                  <div class="col-sm-12">
                                      <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                  </div>
                              </div>
                                <!-- <input type="text" class="form-control" placeholder="" aria-label="">
                                <span class="input-group-btn">
                                    <button class="btn btn-link white-bg" type="button">
                                        <img width="16" src="images/calender.svg" class="m-0" alt="">
                                    </button>
                                </span> -->
                            <!-- </div> -->
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                              <input style="background-color: #fff; cursor: not-allowed" class="form-control" type="email" name="email" data-vv-as="email address" v-model="email" v-validate="'required|email|max:100'" :disabled="true">
                              <i style="font-size: 18px; color: #000; text-align: right; float: right; margin-top: -25px; margin-right: 10px;" class="fa">&#xf023;</i>
                              <span v-show="errors.has('edit.email')" class="text-danger">{{ errors.first('edit.email') }}</span>
                        </div>
                        <div class="form-group">
                            <label>Mobile</label>
                            <input class="form-control" type="text" ref="mobile" name="phone1" data-vv-as="mobile no." v-model="phone1" v-validate="'required|numeric|min:10|max:10'">
                            <span v-show="errors.has('edit.phone1')" class="text-danger">{{ errors.first('edit.phone1') }}</span>
                            <span v-show="isMobileError" class="text-danger">{{ mobileErrorMsg }}</span>
                        </div>
                        <div class="form-group">
                            <label>Alternate Phone No.</label>
                            <input class="form-control" type="text" name="phone2" data-vv-as="alternate phone no." v-model="phone2" v-validate="'numeric|min:10|max:10'">
                            <span v-show="errors.has('edit.phone2')" class="text-danger">{{ errors.first('edit.phone2') }}</span>
                            <span v-show="isError" class="text-danger">{{ 'Sorry something went wrong try again' }}</span> 
                        </div>
                        <button class="btn btn-primary full-width" :disabled="(errors.any())" @click.prevent="saveProfile()">Update</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
      </div>
      <div class="modal fade bd-example-modal-sm" id="inviteFriends" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="material-icons">arrow_back</span>
                    </button>
                    <h5 class="modal-title" id="exampleModalLabel">Refer and earn credit points</h5>
                </div>
                <div class="modal-body">
                    <p class="grey-color">
                      Copy & share the link to your friends & family to earn Rs.{{credits}} worth of Labotist credits, when each referral completes an order through Labotist. Your friend or family member will also earn Labotist credits which they can immediately use.
                    </p>
                    <input type="text" class="copy-link" name="copyReferralText" ref="copyReferralText" id="copyReferralText" v-model="referralUrl" v-on:focus="copyReferralCodeUrl()" v-on:click="copyReferralCodeUrl()" data-toggle="tooltip" data-placement="top" title="Copied">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import _ from 'underscore'
// import Datepicker from 'vuejs-datepicker'
import dateFormat from 'dateformat'

export default {
  name: 'MyProfile',
  props: [],
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone1: '',
      phone2: '',
      dob: '',
      sex: '',
      photo: '',
      address: {},
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: false,
      errormsg: '',
      isDobError: false,
      disabled: {
        from: new Date()
      },
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      isMobileError : false,
      mobileErrorMsg : '',
      isError : false,
      creditPoint: undefined,
      referralCode: '',
      tick : false,
      referralUrl : '',
      credits: ''
    }
  },
  mounted () {
    this.getProfile()
    $('input[data-toggle="tooltip"]').tooltip({
        animated: 'fade',
        placement: 'bottom',
        trigger: 'manual'
    })
  },
  watch: {
    referralUrl: function() {
        this.referralUrl = this.$signupUrl + this.referralCode.toLowerCase()
    }
  },
  created () {
    let year = (new Date()).getFullYear()
    let endYear = year - 120
    for (let i = year; i > endYear; i--) {
      this.dobYears.push(i.toString())
    }
  },
  methods: {
    copyReferralCodeUrl: function () {
      setTimeout(function(){
        this.$refs.copyReferralText.setSelectionRange(0, this.referralUrl.length)
        document.execCommand("copy");
        $('input[data-toggle="tooltip"]').tooltip("show")
        setTimeout(function(){
          $('input[data-toggle="tooltip"]').tooltip("hide")
        }, 1000)
      }.bind(this), 100)
    },
    // getProfile: function () {
    //   try {
    //     if (this.$localStorage.get('loggedIn') === 'true' && this.$localStorage.get('access_token') !== '') {
    //       var data = {}
    //       Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
    //         if (res.response_code === 0) {
    //           if (res.response) {
    //             _.each(res.response.Addresses, function (item) {
    //               if (item.isDefault === 1) {
    //                 this.address = item.address
    //               }
    //             })
    //           }
    //           this.firstName = res.response.Patient.firstName
    //           this.lastName = res.response.Patient.lastName
    //           this.email = res.response.email
    //           this.phone1 = res.response.Patient.phone1
    //           this.phone2 = res.response.Patient.phone2
    //           this.dob = res.response.Patient.dob ? res.response.Patient.dob : ''
    //           this.sex = res.response.Patient.sex
    //         }
    //         this.$hidePageLoading()
    //       }.bind(this)).catch(function (err) {
    //         console.error(err)
    //       })
    //     }
    //   } catch (e) {
    //     console.error('method:getProfile', e)
    //   }
    // },
    savePassword: function () {
      this.$validator.validateAll('password').then((result) => {
        if (result) {
          try {
            this.error = false
            this.errormsg = ''
            var data = {
              'oldPassword': this.oldPassword,
              'newPassword': this.newPassword
            }
            Promise.resolve(this.$POST('patient/changePassword', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$router.push({ path: '/myprofile' })
              } else {
                this.error = true
                this.errormsg = res.response_message
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error('method:save_password', e)
          }
        }
      })
    },
    getNumberOfDays: function (dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        let noOfDays = new Date(this.year, this.month, 0).getDate()
        this.dobDate = []
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString())
        }
        if (dateVal) {
          this.ddate = dateVal
        } else {
          if (this.ddate) {
            var res = true
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false
              }
            }.bind(this))
            if (res) {
              this.ddate = ''
            }
          }
        }
      }
      return false
    },
    saveProfile: function () {
      this.isDobError = false
      this.isMobileError = false
      this.isError = false
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          if (this.year.length !== 4 || this.month.length <= 0 || this.ddate.length <= 0) {
            this.isDobError = true
            return false
          }
          try {
            var data = {
              'firstName': this.firstName,
              'lastName': this.lastName,
              'phone1': this.phone1,
              'phone2': this.phone2,
              'photo': '',
              'sex': this.sex,
              'dob': this.year + '-' + this.month + '-' + this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            }
            console.log(data)
            Promise.resolve(this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile')
                var userDetails = {
                  'username': this.firstName + ' ' + this.lastName,
                  'firstName': this.firstName,
                  'lastName': this.lastName,
                  'phone1': this.phone1,
                  'dob': dateFormat(this.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                }
                this.$localStorage.set('profile', userDetails, 0)
                // this.$router.push({path : '/myprofile'})
                $('#editProfile').modal('toggle');
              } else if(res.response_code === 4){
                this.isMobileError = true
                this.mobileErrorMsg = res.response_message
                this.$refs.mobile.focus()
              } else if(res.response_code === 2){
                this.isError = true
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error('method:saveProfile', e)
          }
        }
      })
    },
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                _.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address
                  }
                })
              }
              this.firstName = res.response.Patient.firstName
              this.lastName = res.response.Patient.lastName
              this.email = res.response.email
              this.phone1 = res.response.Patient.phone1
              this.phone2 = res.response.Patient.phone2
              this.dob = res.response.Patient.dob ? res.response.Patient.dob : undefined
              this.sex = res.response.Patient.sex
              this.creditPoint = res.response.Patient.creditPoint
              this.referralCode = res.response.Patient.referralCode
              this.credits = res.response.credits
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                let dob = (res.response.Patient.dob).split('T')
                let dobDate = dob[0].split('-')
                this.year = dobDate[0]
                this.month = dobDate[1]
                this.getNumberOfDays(dobDate[2])
              }
            }
            this.referralUrl = this.$signupUrl + this.referralCode.toLowerCase()
            this.$hidePageLoading()
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Secure/MyProfile.vue